import React from 'react';
import { Check, ShieldCheck } from 'lucide-react';
import { COPY } from '../../i18n/copy';
import { useI18n } from '../../i18n/useI18n';

const EricaSecurity: React.FC = () => {
  const { lang } = useI18n();
  const c = COPY[lang];

  return (
    <section id="security" className="bg-white py-16 sm:py-20">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-3xl text-center">
          <h2 className="text-3xl font-semibold tracking-tight text-slate-900 sm:text-4xl">
            {c.security.title}
          </h2>
          <p className="mt-4 text-lg text-slate-600">{c.security.subtitle}</p>
        </div>

        <div className="mx-auto mt-10 max-w-4xl rounded-2xl border border-slate-200 bg-slate-50 p-6 shadow-sm sm:p-8">
          <div className="flex items-center gap-3">
            <div className="flex h-11 w-11 items-center justify-center rounded-xl border border-slate-200 bg-white">
              <ShieldCheck className="h-6 w-6 text-slate-900" />
            </div>
            <div className="text-sm font-semibold text-slate-900">
              {lang === 'id' ? 'Ringkas' : 'At a glance'}
            </div>
          </div>

          <ul className="mt-6 space-y-3">
            {c.security.bullets.map((bullet) => (
              <li key={bullet} className="flex gap-3 text-sm text-slate-700">
                <span className="mt-0.5 inline-flex h-5 w-5 flex-shrink-0 items-center justify-center rounded-full bg-white text-slate-900 shadow-sm ring-1 ring-slate-200">
                  <Check className="h-3.5 w-3.5" />
                </span>
                <span className="leading-relaxed">{bullet}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default EricaSecurity;
